import React, { Children } from 'react';
import Cardactions from '@material-ui/core/CardActions';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  cardFooter: {
    margin: '0 20px 20px',
  },
}));

export function CardFooter(props) {
  const classes = useStyles();
  const { children, ...rest } = props;
  return (
    <Cardactions className={classes.cardFooter} {...rest}>
      {props.children}
    </Cardactions>
  );
}
